import { jwtDecode, JwtPayload } from "jwt-decode";

interface DecodedToken extends JwtPayload {
  role_id?: number;
  sub?: string;
}

const getRoleId = (token: any) => {
  if (!token) {
    return null;
  }
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded?.role_id;
  } catch (error) {
    return null;
  }
};

// این تابع صرفاً باید انقضای توکن را محاسبه کند؛ نباید localStorage را پاک کند. قبلاً روی هر
// خطای decode (حتی گذرا)، خودش app_at_mahan را حذف می‌کرد و باعث می‌شد کاربر بلافاصله بعد از
// ورود موفق دوباره به صفحه‌ی لاگین پرتاب شود. پاک‌کردن نشست وظیفه‌ی فراخوان (مثل isAuthValid) است.
const getTokenExpiration = (token: any) => {
  if (!token) {
    return null;
  }
  try {
    const decode = jwtDecode<DecodedToken>(token);
    if (decode.exp) {
      return new Date(decode.exp * 1000);
    }
    return null;
  } catch (error) {
    return null;
  }
};

const getUsername = (token: string | null): string | null => {
  if (!token) return null;
  try {
    const decoded = jwtDecode<DecodedToken>(token);
    return decoded?.sub || null;
  } catch (error) {
    return null;
  }
};

export { getTokenExpiration, getRoleId, getUsername };
